<template>
  <v-dialog
    v-model="modal"
    fullscreen
    persistent
  >
  <v-toolbar
    flat
    dark
    color="primary"
  >
  <v-toolbar-title class="h2">アンケートにお答えください</v-toolbar-title>
  <v-spacer></v-spacer>
  </v-toolbar>
    <v-card>
      <!-- 通知設定本体 -->
      <attributionSetting :initialMode="true" />

    </v-card>
  </v-dialog>
</template>
<script>
import attributionSetting from './attributionSetting.vue';
export default {
  data() {
    return {
      modal: true,
    };
  },
  components: {
    attributionSetting,
  },
}
</script>